module.exports = __webpack_public_path__ + "img/icon_next-b-rev.a0e04725.svg";